var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-8.99034,-2.92186)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.99,
    cy: 34.922,
    r: 20.088,
    style: {
      fill: "rgb(255,233,160)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.07,33.76L33.758,45.08C33.278,45.56 32.622,46.065 32,45.945C31.378,46.065 30.722,45.56 30.242,45.08L18.93,33.76C18.148,32.98 18.148,31.72 18.93,30.92C19.71,30.14 20.976,30.14 21.758,30.92L30,39.18L30,18C30,16.9 30.896,16 32,16C33.106,16 34,16.9 34,18L34,39.18L42.242,30.92C43.024,30.14 44.292,30.14 45.07,30.92C45.852,31.72 45.852,32.98 45.07,33.76ZM32,0C14.326,0 0,14.32 0,32C0,49.68 14.326,64 32,64C49.674,64 64,49.68 64,32C64,14.32 49.674,0 32,0Z",
    style: {
      fill: "rgb(216,30,6)",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a1c2cd842b21d4e537b3622573310dda.svg";
export { ForwardRef as ReactComponent };